import React, { useState, useEffect } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import Media from 'react-media'
import Link from 'gatsby-link'
import { CSSTransition } from 'react-transition-group'
import { Location } from '@reach/router'

import { desktop, mobile } from '../utils/media-query'
import GetStartedLoginButton from './get-started-login-button'
import NavLinks from './nav-links'
import Menu from '../icons/menu'
import ModalMenu from './modal-menu'
import { Button } from '../create-app-button'
import { containerWidth, headerHeight, menu } from '../constants'
import giphyLogoImg from '../../images/header-logo.gif'
import CreateNewApp from '../utils/qa-events'

const NavContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: ${headerHeight}px;
    color: white;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 6px;

    ${props =>
        !props.theme.disableMobileQueries
            ? desktop.css`
        width: ${containerWidth}px;
    `
            : `width: ${containerWidth}px;`}

    ${props =>
        !props.theme.disableMobileQueries
            ? mobile.css`
        width: 100vw;
        margin: 0;
        padding: 0 14px;
    `
            : ''}

    img {
        width: 310px;

        ${props =>
            !props.theme.disableMobileQueries
                ? mobile.css`
            width: 250px;
        `
                : ''}
    }

    a {
        color: white;
    }
`

const GlobalStyle = createGlobalStyle`
    body {
        overflow: hidden;
    }
`

const ModalMenuContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    &.fadeScale.enter {
        opacity: 0.01;
        transform: scale(0.95);
    }

    &.fadeScale.enter-active {
        opacity: 1;
        transform: scale(1);
        transition: opacity 200ms ease-in, transform 200ms ease-in;
    }

    &.fadeScale.exit {
        opacity: 1;
        transform: scale(1);
    }

    &.fadeScale.exit-active {
        opacity: 0.01;
        transform: scale(0.95);
        transition: opacity 200ms ease-in, transform 200ms ease-in;
    }
`

const MenuButton = styled.div`
    width: 30px;
    height: 42px;
    position: relative;
    z-index: 2;
`

const ExtendedLink = styled(Link)`
    border-bottom: none;
    color: white;
`

const StyledButton = styled(Button)`
    width: 140px;
    margin: 0;
    margin-right: 15px;
    line-height: 36px;
    border-bottom: none;
`

const Header = ({ hasLogin = false }: { hasLogin?: boolean }) => {
    const [showModalMenu, setShowModalMenu] = useState(false)
    const [mounted, setMounted] = useState(false)
    useEffect(() => setMounted(true), [])

    const onMenuClick = () => {
        setShowModalMenu(!showModalMenu)
    }

    return (
        <NavContainer>
            <ExtendedLink to={'/'}>
                <img src={giphyLogoImg} />
            </ExtendedLink>
            <Media query={desktop.query}>
                {matches =>
                    mounted ? (
                        matches || location.pathname.includes('docs') ? (
                            <>
                                <NavLinks titles={menu} />
                                <Location>
                                    {({ location }) =>
                                        location.pathname !== '/' && (
                                            <StyledButton href="/dashboard/?create=true" onClick={CreateNewApp}>
                                                Create an App
                                            </StyledButton>
                                        )
                                    }
                                </Location>
                                {hasLogin ? (
                                    <GetStartedLoginButton isLogin={hasLogin} />
                                ) : (
                                    <ExtendedLink to={'/docs/sdk'}>
                                        <GetStartedLoginButton />
                                    </ExtendedLink>
                                )}
                            </>
                        ) : (
                            <>
                                {showModalMenu && <GlobalStyle />}
                                <MenuButton onClick={onMenuClick}>
                                    <Menu isActive={showModalMenu} />
                                </MenuButton>
                                <CSSTransition in={showModalMenu} className="fadeScale" unmountOnExit timeout={200}>
                                    <ModalMenuContainer>
                                        <ModalMenu
                                            isLogin={hasLogin}
                                            titles={menu.map((title: any) => ({ ...title, hasDropdown: false }))}
                                        />
                                    </ModalMenuContainer>
                                </CSSTransition>
                            </>
                        )
                    ) : null
                }
            </Media>
        </NavContainer>
    )
}

export default Header
